// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__X6Pk1","col":"Table_col__5DIQb","fulfillmentStatus":"Table_fulfillmentStatus__2CM3U","emailCol":"Table_emailCol__30_aG"};